// extracted by mini-css-extract-plugin
export var carrierTab = "_51-0";
export var carrierTabActive = "_51-1 _51-0";
export var carrierTabInactive = "_51-2 _51-0";
export var carrierTabLabel = "_51-3";
export var carrierTabLabelActive = "_51-4 _51-3";
export var carrierTabLabelInactive = "_51-5 _51-3";
export var carrierTabPercentage = "_51-6";
export var carrierTabPercentageActive = "_51-7 _51-6";
export var carrierTabPercentageInactive = "_51-8 _51-6";
export var carrierTabWinnable = "_51-9";
export var carrierTabWinnableActive = "_51-a _51-9";
export var carrierTabWinnableInactive = "_51-b _51-9";
export var comparisonContainer = "_51-d";
export var missingRateButton = "_51-n";
export var missingRateButtonActive = "_51-o _51-n";
export var missingRateButtonInactive = "_51-p _51-n";
export var missingRateButtonLabel = "_51-q";
export var missingRateButtonLabelActive = "_51-r _51-q";
export var missingRateButtonLabelInactive = "_51-s _51-q";
export var sidebar = "_51-c";
export var strategyButton = "_51-e";
export var strategyButtonActive = "_51-f _51-e";
export var strategyButtonDescription = "_51-k";
export var strategyButtonDescriptionActive = "_51-l _51-k";
export var strategyButtonDescriptionInactive = "_51-m _51-k";
export var strategyButtonInactive = "_51-g _51-e";
export var strategyButtonLabel = "_51-h";
export var strategyButtonLabelActive = "_51-i _51-h";
export var strategyButtonLabelInactive = "_51-j _51-h";
export var unitToggleButton = "_51-t";
export var unitToggleButtonActive = "_51-u _51-t";
export var unitToggleButtonInactive = "_51-v _51-t";
export var unitToggleButtonLabel = "_51-w";
export var unitToggleButtonLabelActive = "_51-x _51-w";
export var unitToggleButtonLabelInactive = "_51-y _51-w";